module.exports = __webpack_public_path__ + "img/multiplica.cbe9b6a5.gif";